import { useState } from "react";
import {  useNewPassMutation } from "context/auth/authApiSlice"; 
import { useDispatch, useSelector } from "react-redux";
import { setCredentials, selectCurrentUser } from "context/auth/authSlice";
import { useForm, Controller  } from "react-hook-form";
import { useMaterialUIController } from "context";
import useHelper from "hooks/useHelper";
// @mui material components
import { Grid, Icon, Container,  InputAdornment, LinearProgress } from "@mui/material";
import { useParams, useLocation } from "react-router-dom" ;

// Material Kit 2 React components
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";
import MDButton from "dashboard/components/MDButton";
import MDInput from "dashboard/components/MDInput";
import MDAlert from "dashboard/components/MDAlert";
import CoverLayout from "components/layouts/CoverLayout";
import bgImage from "assets/images/bg-profile.jpeg";

function NewPassword() {
  const [controller] = useMaterialUIController();
  const { pageContent } = controller;
  const {token}  = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const connectedUser = useSelector(selectCurrentUser);
  const  [errorMsg, setErrorMsg] = useState("");
  const { isMatchPass, isValidPass, isValidNumber } = useHelper();
  const [showpassword, setShowPassword] = useState({password : true, oldPassword : true, rePassword : true});
  const showPassword = e =>{
    const attName = e.target.getAttribute('name');
    setShowPassword({...showpassword, [attName] : !showpassword[attName]})
  };

  const { register, handleSubmit, control, getValues, formState: { errors } } = useForm({
    mode: "all",
    defaultValues:{
      oldPassword : '',
      password : '',
      rePassword : '',
      random : ''
  }});
    
  const [passChange,{isLoading, isSuccess}] = useNewPassMutation();

  const onSubmit = async data =>{   
    const {oldPassword, password,  random : randomNumber } = data;
    try{
    /*eslint-disable*/
    const userData = await passChange({oldPassword, password, randomNumber, token, email : location?.state?.email, userId : connectedUser?.id}).unwrap();
    dispatch(setCredentials({accessToken : userData.accessToken,  user:userData.user}));
    } catch(err) {
      setErrorMsg(`${err.data?.error.toString()}`);
    }
  }

  return (
    <CoverLayout coverHeight="50vh" rest lg={6} image={bgImage}>
      <Container sx={{my:4}}>      
        <Grid container spacing={3} alignItems="center">
          <Grid
            item
            xs={12}
            sm={10}
            ml={{ xs: "auto" }}
            mr={{ xs: "auto"}}
            mt={-8}
          >
            <MDBox
              borderRadius="xl"
              shadow="lg"
              display="flex"
              flexDirection="column"
              justifyContent="center"
              mx={3}
              sx={{
                backgroundColor: ({ palette: { background }, functions: { rgba } }) => rgba(background.card, 1),
              }}
            >
              {/* eslint-disable */}
              <MDBox
                variant="gradient"
                bgColor="info"
                coloredShadow="info"
                borderRadius="lg"
                p={2}
                mx={2}
                mt={-3}
              >
                <MDTypography variant="h3" color="white">
                  New password 
                </MDTypography>
              </MDBox>
              <MDBox pt={4} pb={3} px={3}>
                {isLoading && <LinearProgress color="info"   sx={{ marginBottom:"15px", width:"100%", overflowX:"hidden"}} />}
                {location?.state?.email && <MDAlert color="light"><MDTypography variant="body2" sx={{color:`#000000 !important`}}>
                  Please check your email account to get the sécurity code or the link to reset your password
                </MDTypography></MDAlert>}
                <MDBox component="form" onSubmit={handleSubmit(onSubmit)} noValidate role="form">
                  {connectedUser && <MDBox mb={2}>
                    <Controller name="oldPassword" control={control} 
                        render={({ field: { onChange, value } }) => (
                        <MDInput   onChange={onChange} value={value} type={showpassword.oldPassword ? "password" : "text"} label="old Password" required fullWidth 
                            {...register("oldPassword", { required: "Please enter your old Password.", validate : isValidPass })}
                            error={Boolean(errors.oldPassword)}
                            helperText={errors.oldPassword?.message}
                            InputProps={{
                              endAdornment: (
                                  <InputAdornment position="end">
                                      <Icon name="oldPassword" sx={{ cursor:"pointer" }} fontSize="medium"  onClick={showPassword}>{showpassword.oldPassword ? "visibility" : "visibility_off"}</Icon>
                                  </InputAdornment>
                              )}}
                            />
                        )}
                      />
                  </MDBox>}
                  {(!token && !connectedUser) && <MDBox mb={2}>
                    <Controller name="random" control={control} 
                        render={({ field: { onChange, value } }) => (
                        <MDInput   onChange={onChange} value={value} type="number" label="Security code" required fullWidth 
                            {...register("random", { required: "Please enter the security code sent to you by email.", maxLength: 8, minLength: 8, validate : isValidNumber })}
                            error={Boolean(errors.random)}
                            helperText={errors.random?.message}
                            />
                        )}
                      />
                  </MDBox>}
                  <MDBox mb={2}>
                    <Controller name="password" control={control} 
                        render={({ field: { onChange, value } }) => (
                        <MDInput   onChange={onChange} value={value} type={showpassword.password ? "password" : "text"} label="Password" required fullWidth 
                            {...register("password", { required: "password is required.", validate : isValidPass })}
                            error={Boolean(errors.password)}
                            helperText={errors.password?.message}
                            InputProps={{
                              endAdornment: (
                                  <InputAdornment position="end">
                                      <Icon name="password" sx={{ cursor:"pointer" }} fontSize="medium"  onClick={showPassword}>{showpassword.password ? "visibility" : "visibility_off"}</Icon>
                                  </InputAdornment>
                              )}}
                            />
                        )}
                      />
                  </MDBox>
                  <MDBox mb={2}>
                    <Controller name="rePassword" control={control} 
                        render={({ field: { onChange, value } }) => (
                        <MDInput   onChange={onChange} value={value} type={showpassword.rePassword ? "password" : "text"} label="Confirm  Password" required fullWidth 
                            {...register("rePassword", { required: "this field must match the new password.", validate : value => isMatchPass(value, getValues('password')) })}
                            error={Boolean(errors.rePassword)}
                            helperText={errors.rePassword?.message}
                            InputProps={{
                              endAdornment: (
                                  <InputAdornment position="end">
                                      <Icon name="rePassword" sx={{ cursor:"pointer" }} fontSize="medium"  onClick={showPassword}>{showpassword.rePassword ? "visibility" : "visibility_off"}</Icon>
                                  </InputAdornment>
                              )}}
                            />
                        )}
                      />
                  </MDBox>
                  <MDBox mt={6} mb={1}>
                    <MDButton type="submit" variant="gradient" color="info" fullWidth>
                      validate
                    </MDButton>
                  </MDBox>
                  {errorMsg && <MDAlert color="error"><small style={{ fontSize:"13px",whiteSpace: "normal" }}> {errorMsg} </small></MDAlert> }
                  {(isSuccess && !errorMsg) && <MDAlert color="success"><small style={{ fontSize:"14px",whiteSpace: "normal" }}> Thank you,  You changed your password successfully </small></MDAlert> }
                </MDBox>
              </MDBox>
            </MDBox>
          </Grid>
        </Grid>
      </Container>
    </CoverLayout>
  );
}

export default NewPassword;
